function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n      fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M119.42,203.59c-3.85,9.32-7.47,18.09-11.1,26.85-2.27,5.48-4.66,10.92-6.8,16.46-.52,1.34-.65,3.11-.26,4.48,3.94,13.8,8.04,27.56,12.08,41.33.22.75.39,1.52.64,2.51-.89.08-1.63.2-2.37.2-26.97,0-53.93.02-80.9,0-9.33,0-15.82-5.32-15.96-13.62-.05-3.33.78-6.99,2.26-9.99,10.03-20.33,20.4-40.49,30.52-60.78,2.71-5.43,6.58-7.65,12.76-7.55,18.43.31,36.88.12,55.32.12,1.08,0,2.16,0,3.81,0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M146.85,295.31h-22.5c-2.8-9.51-5.6-19-8.4-28.48-1.54-5.22-3.17-10.42-4.57-15.68-.32-1.22-.24-2.77.23-3.93,5.64-13.84,11.38-27.65,17.17-41.43.38-.89,1.47-2.1,2.26-2.12,6.92-.17,13.85-.1,21.3-.1-1.81,4.46-3.47,8.54-5.12,12.63-4.08,10.09-8.07,20.23-12.29,30.26-.97,2.31-.9,4.28-.22,6.56,4.08,13.75,8.07,27.53,12.08,41.31.08.27.04.57.06.98Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M185.45,251.48c2.67,10.61,5.32,21.14,7.97,31.66.2,0,.41.02.61.02.91-3.49,1.85-6.98,2.74-10.48,1.64-6.43,3.18-12.88,4.94-19.28.23-.82,1.42-1.88,2.24-1.95,2.73-.25,5.5-.09,8.53-.09-4.25,14.87-8.42,29.5-12.6,44.13h-12.82c-2.71-10.54-5.4-21.03-8.09-31.52-.2-.02-.4-.04-.6-.06-.29.98-.61,1.96-.86,2.95-2.23,8.82-4.48,17.64-6.62,26.48-.43,1.78-1.21,2.41-3.04,2.29-3.43-.23-7.75.95-10.07-.72-2.17-1.56-2.25-6.05-3.2-9.27-3.06-10.45-6.09-20.92-9.13-31.38-.24-.84-.44-1.69-.72-2.74h11.03c2.66,10.51,5.32,21.03,7.98,31.55.21.03.42.06.63.09,2.56-10.56,5.11-21.13,7.66-31.68h13.42Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M144.69,247.64c5.86-14.53,11.51-28.57,17.25-42.58.28-.68,1.42-1,2.17-1.47.07-.05.19,0,.29,0,8.78-.37,8.75-.36,12.1,7.93,4.49,11.1,9.03,22.19,13.54,33.28.33.8.6,1.63,1.06,2.85-3.34,0-6.37.11-9.38-.08-.68-.04-1.53-1.02-1.9-1.77-1.3-2.63-1.74-6.32-3.8-7.74-1.96-1.36-5.54-.4-8.41-.44-1.68-.02-3.41.24-5.05-.05-3.27-.59-4.46,1.11-5.43,3.85-2.21,6.25-2.31,6.21-9.03,6.24-.98,0-1.97,0-3.42,0ZM173.8,229.93c-2.02-5.52-3.93-10.73-6.12-16.69-2.17,5.99-4.06,11.2-6.05,16.69h12.17Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M279.85,251.4h8.72v43.96h-8.12c-.18-.54-.43-1.31-.75-2.28-3.57,2.91-7.47,3.75-11.8,3.11-4.68-.69-7.85-3.34-9.52-7.56-2.26-5.7-2.44-11.63-.45-17.45,2.99-8.77,12.65-11.79,20.27-6.48.38.26.77.52,1.65,1.11v-14.41ZM265.52,279.17c.71,2.46,1.05,4.86,2.08,6.93,1.93,3.86,6.8,4.32,9.72,1.15,3.51-3.81,3.25-12.61-.48-16.2-2.87-2.77-7.22-2.36-9.07,1.14-1.11,2.12-1.52,4.62-2.25,6.98Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M263.27,214.14c10.05-.26,17,6.5,17.42,16.93.39,9.82-6.57,17.02-16.7,17.28-10.1.26-17.34-6.49-17.59-16.41-.26-10.36,6.55-17.55,16.88-17.81ZM255.79,231.78c.18.94.34,2.74.9,4.39,1.19,3.5,3.73,5.21,7.13,5.1,3.31-.1,5.91-2.04,6.76-5.59.54-2.26.79-4.7.61-7.01-.36-4.51-3.66-7.51-7.72-7.48-3.98.03-7.11,3.21-7.55,7.69-.07.69-.07,1.38-.14,2.91Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M394.83,282.11h-22.21c.3,7.88,7.35,9.42,19.43,4.35,0,2.15.17,4.19-.09,6.17-.09.74-1.03,1.68-1.8,1.99-6.05,2.38-12.28,2.74-18.21-.02-6.99-3.26-8.64-9.66-8.34-16.69.47-11.14,8.45-17.41,19.3-15.34,5.02.96,8.52,3.83,9.9,8.75.95,3.37,1.32,6.91,2.03,10.8ZM385.49,275.66c-.33-4.51-2.72-6.9-6.48-6.76-3.86.15-6.25,2.62-6.37,6.76h12.85Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M427.53,282.12h-21.94c-.25,7.55,6.37,9.03,19.31,4.45,0,1.93.18,3.81-.08,5.62-.12.87-.9,2.02-1.68,2.35-5.09,2.16-10.4,2.48-15.71,1.05-5.93-1.6-9.71-5.59-10.39-11.63-.44-3.93-.3-8.17.73-11.97,1.8-6.65,7.75-10.2,14.87-9.83,7.46.38,11.9,3.85,13.62,10.97.66,2.76.82,5.64,1.27,9ZM405.4,275.59h13.06c-.68-4.68-2.84-6.83-6.53-6.71-3.75.12-6.06,2.44-6.53,6.71Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M429.31,295.42v-32.24h8.24c.15.86.29,1.7.46,2.71.44-.21.77-.39,1.12-.53,2.51-1.06,4.95-2.65,7.56-3.05,6.54-1.01,11.68,2.59,12.18,9.17.6,7.86.14,15.8.14,23.91h-8.6c0-5.15,0-10.18,0-15.21,0-1.78.03-3.58-.12-5.35-.22-2.5-1.02-4.7-3.8-5.42-2.52-.66-5.56.59-6.62,3.29-.96,2.42-1.49,5.13-1.62,7.74-.25,4.93-.07,9.88-.07,14.99h-8.85Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M191.04,215.01h8.5c0,5.04-.05,9.96.02,14.88.03,2.37-.09,4.85.57,7.06.47,1.56,1.92,3.56,3.31,3.92,1.59.42,3.94-.29,5.36-1.33,2.7-1.96,2.94-5.25,3-8.35.09-5.32.02-10.65.02-16.15h8.84v32.38h-8.07c-.14-.91-.3-1.91-.41-2.57-2.9,1.14-5.68,2.73-8.66,3.29-6.39,1.2-11.85-2.46-12.35-8.92-.61-7.95-.15-15.99-.15-24.22Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M253.6,295.48h-8.61c0-5.13.03-10.15-.02-15.17-.02-2.07-.11-4.16-.35-6.22-.27-2.3-1.25-4.27-3.8-4.7-2.69-.46-5.16.37-6.27,2.89-1.01,2.29-1.66,4.89-1.79,7.38-.27,5.13-.08,10.29-.08,15.68h-8.73v-32.09h8.03c.11.75.24,1.59.39,2.62.37-.13.77-.16,1.01-.38,2.56-2.3,5.6-3.28,8.98-3.34,6.27-.1,10.87,3.65,11.15,9.89.35,7.7.08,15.42.08,23.42Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M483.59,263.43c-.16,2.4-.3,4.46-.46,6.68-2.19-.4-4.25-.93-6.35-1.12-1.34-.12-2.84-.01-4.05.49-.84.35-1.79,1.53-1.83,2.38-.04.8.87,1.99,1.68,2.41,1.65.86,3.51,1.3,5.28,1.94,5.26,1.91,7.45,4.74,7.4,9.51-.05,4.91-2.65,8.24-7.92,9.81-5.2,1.56-10.34.88-15.7-.67.24-2.47.47-4.8.7-7.09,2.35.67,4.5,1.5,6.72,1.82,1.49.21,3.22-.01,4.59-.62.97-.43,2.07-1.83,2.08-2.81.01-.98-1.05-2.39-2.01-2.88-2-1.03-4.28-1.5-6.39-2.33-4.2-1.66-5.88-4.07-5.91-8.3-.03-4.18,1.8-7.22,5.63-8.97,5.38-2.45,10.82-1.48,16.54-.25Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M313.53,263.54c-.21,2.26-.42,4.39-.62,6.55-2.08-.39-3.99-.86-5.94-1.07-1.25-.13-2.68-.19-3.78.29-1.02.45-2.17,1.55-2.38,2.56-.15.7,1.01,2.03,1.89,2.52,1.44.81,3.14,1.16,4.72,1.72,5.66,2.01,7.84,4.81,7.68,9.88-.14,4.86-3.1,8.44-8.45,9.76-5.01,1.24-9.99.7-15.08-.91.21-2.44.41-4.76.61-7.08,2.33.66,4.47,1.45,6.68,1.84,1.31.23,2.9.2,4.04-.37,1.16-.58,2.62-1.95,2.65-3.01.03-1.06-1.33-2.56-2.46-3.16-1.98-1.05-4.27-1.53-6.4-2.31-3.58-1.31-5.35-4.02-5.47-7.72-.12-3.69,1.18-6.77,4.54-8.73,4.48-2.62,9.28-2.37,14.14-1.58,1.15.19,2.28.52,3.6.83Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M229.37,221.68c-2.24-.1-4-.18-5.99-.26v-6.46h5.56c.35-2.38-.06-5.36,1.13-6.32,2.01-1.61,5.04-1.93,8-2.92v8.97h7.43v6.81h-7.21c0,5.62-.24,10.85.08,16.05.22,3.56,2.19,4.23,7.57,3.07.14,2.27.28,4.49.43,6.97-1.69.25-3.22.55-4.76.68-7.97.66-12.18-3.18-12.24-11.16-.04-5.04,0-10.09,0-15.45Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M341.19,263.33c-.29,2.51-.56,4.73-.83,7.08-4.61-1.47-8.89-2.23-12.12,2.08-2.68,3.57-2.67,9.73-.13,13.48,2.28,3.37,5.16,3.84,12.97,2.1.11.13.32.27.32.41.3,8.1,1.95,7.21-6.99,7.86-8.63.63-14.81-3.71-16.68-11.15-2.31-9.17.71-17.9,7.47-21.27,5.08-2.53,10.34-2.05,16.01-.59Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M344.61,295.41v-32.19h7.59c.14,1.25.29,2.55.49,4.36,3.39-4.51,7.17-6.78,12.76-4.42-.72,2.54-1.44,5.05-2.12,7.45-.35.16-.54.33-.7.3-7.17-1.18-8.72,3.3-9.1,8.62-.19,2.66-.06,5.34-.07,8.02,0,2.56,0,5.12,0,7.85h-8.86Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M211.86,262.99h8.29v32.5h-8.29v-32.5Z"
});

var SvgChasAutoWindscreens = function SvgChasAutoWindscreens(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "120 120 250 250",
    width: 180,
    height: 150,
    style: {
      backgroundColor: "#202F58"
    },
    id: "Layer_1",
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasAutoWindscreens, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chas-auto-windscreens.2c5e20f4.svg";
export { ForwardRef as ReactComponent };